module.exports = "<div><% _.forEach(users, function(user) { %>- <%- user %><br><% }); %></div>";